import { useReveal } from '../hooks/useReveal';

function OnlineViz() {
  return (
    <svg className="ca-viz ca-viz--online" viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <defs>
        <linearGradient id="caVizOnlineGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f87171" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#dc2626" stopOpacity="0.4" />
        </linearGradient>
      </defs>
      <path
        className="ca-viz__cloud"
        d="M110 28c-12 0-22 8-25 19-14 2-24 14-24 28 0 16 13 29 29 29h102c16 0 29-13 29-29 0-13-9-24-21-27-3-16-17-28-34-28-8 0-15 3-21 8-5-10-15-17-27-17-16 0-29 12-31 28z"
        fill="rgba(248,113,113,0.12)"
        stroke="rgba(248,113,113,0.45)"
        strokeWidth="1.2"
      />
      <rect className="ca-viz__device" x="82" y="118" width="56" height="72" rx="8" stroke="rgba(248,113,113,0.5)" strokeWidth="1.5" fill="rgba(18,18,28,0.9)" />
      <path
        className="ca-viz__flow ca-viz__flow--up"
        d="M110 118 C110 95 110 75 110 58"
        stroke="url(#caVizOnlineGrad)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="6 10"
      />
      <g className="ca-viz__packet-wrap">
        <circle className="ca-viz__packet ca-viz__packet--a" cx="0" cy="0" r="4.5" fill="#f87171" />
        <circle className="ca-viz__packet ca-viz__packet--b" cx="0" cy="0" r="2.8" fill="#fecaca" opacity="0.85" />
      </g>
    </svg>
  );
}

function OfflineViz() {
  return (
    <svg className="ca-viz ca-viz--offline" viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        className="ca-viz__cloud ca-viz__cloud--muted"
        d="M110 30c-14 0-26 9-29 22-12 2-21 13-21 26 0 15 12 27 27 27h96c15 0 27-12 27-27 0-12-8-22-19-25-3-14-15-25-30-25-7 0-14 2-19 7-5-9-14-15-25-15-14 0-26 10-29 24z"
        fill="rgba(100,116,139,0.06)"
        stroke="rgba(100,116,139,0.22)"
        strokeWidth="1.2"
      />
      <line className="ca-viz__slash" x1="68" y1="34" x2="152" y2="78" stroke="rgba(148,163,184,0.55)" strokeWidth="1.6" strokeLinecap="round" />
      <rect className="ca-viz__device" x="82" y="118" width="56" height="72" rx="8" stroke="rgba(74,222,128,0.55)" strokeWidth="1.5" fill="rgba(18,18,28,0.9)" />
      <ellipse cx="110" cy="168" rx="22" ry="10" fill="rgba(74,222,128,0.08)" stroke="rgba(74,222,128,0.35)" strokeWidth="1" />
      <path
        d="M98 168h24"
        stroke="rgba(74,222,128,0.5)"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <rect x="96" y="152" width="28" height="14" rx="2" fill="rgba(74,222,128,0.15)" stroke="rgba(74,222,128,0.4)" strokeWidth="0.8" />
      <path
        className="ca-viz__local-ring"
        d="M110 138a20 20 0 1 0 0.01 0"
        stroke="rgba(74,222,128,0.45)"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
}

function HybridViz() {
  return (
    <svg className="ca-viz ca-viz--hybrid" viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <defs>
        <linearGradient id="caVizHyb1" x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#94a3b8" stopOpacity="0.2" />
          <stop offset="50%" stopColor="#f87171" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#94a3b8" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <path
        className="ca-viz__cloud ca-viz__cloud--small"
        d="M56 44c-8 0-14 5-16 12-9 1-15 9-15 18 0 10 8 18 18 18h52c10 0 18-8 18-18 0-8-5-15-12-17-2-10-11-18-22-18-5 0-9 2-13 5-3-6-9-10-16-10-10 0-18 7-19 16z"
        fill="rgba(248,113,113,0.1)"
        stroke="rgba(248,113,113,0.4)"
        strokeWidth="1"
      />
      <rect className="ca-viz__device" x="82" y="108" width="56" height="72" rx="8" stroke="rgba(248,113,113,0.55)" strokeWidth="1.5" fill="rgba(18,18,28,0.95)" />
      <g className="ca-viz__sync-disk">
        <ellipse cx="164" cy="168" rx="26" ry="11" fill="rgba(148,163,184,0.08)" stroke="rgba(148,163,184,0.35)" strokeWidth="1" />
        <rect x="146" y="148" width="36" height="18" rx="2" fill="rgba(148,163,184,0.12)" stroke="rgba(148,163,184,0.4)" strokeWidth="0.8" />
      </g>
      <path
        className="ca-viz__hyb-path ca-viz__hyb-path--down"
        d="M110 108 L110 88 L56 72"
        stroke="url(#caVizHyb1)"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
      <path
        className="ca-viz__hyb-path ca-viz__hyb-path--up"
        d="M164 148 L140 120 L110 108"
        stroke="url(#caVizHyb1)"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
      <g className="ca-viz__sync-dot-wrap" transform="translate(110 108)">
        <circle className="ca-viz__sync-dot" cx="0" cy="0" r="5" fill="#f87171" />
      </g>
    </svg>
  );
}

const modes = [
  {
    key: 'online',
    title: 'Fully online',
    lead: 'Cloud-native experiences with live data, auth, and collaboration—always current, globally reachable.',
    points: ['Instant updates & centralized control', 'Ideal for distributed teams & SaaS', 'Elastic scale when demand spikes'],
    Viz: OnlineViz,
  },
  {
    key: 'offline',
    title: 'Fully offline',
    lead: 'Field sites, factories, or regions with no reliable internet—apps keep working with local storage and sync queues.',
    points: ['Zero connectivity required at the edge', 'Data integrity when the link drops', 'Peace of mind for regulated environments'],
    Viz: OfflineViz,
  },
  {
    key: 'hybrid',
    title: 'Hybrid smart',
    lead: 'The best of both: offline resilience with cloud power when the network returns—tailored to your operations.',
    points: ['Conflict-safe sync & merge strategies', 'Lower downtime, happier users', 'One codebase, multiple deployment modes'],
    Viz: HybridViz,
  },
];

export default function DeploymentModes() {
  const [ref, visible] = useReveal();

  return (
    <section id="reach" className="ca-section ca-section--reach" ref={ref} data-analytics-section="reach">
      <div className="ca-container">
        <header className={`ca-section-head ca-reach__head ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <p className="ca-eyebrow">Run anywhere</p>
          <h2 className="ca-section-title">Online, offline, or hybrid—we shape the stack to your business</h2>
          <p className="ca-section-lead ca-reach__intro">
            CrimsonArc Technologies builds applications that match how your teams actually work: always connected in the cloud, resilient
            with no internet at all, or intelligently hybrid so productivity never depends on a single mode of connectivity.
          </p>
        </header>

        <ul className="ca-reach-grid">
          {modes.map((m, i) => {
            const V = m.Viz;
            return (
              <li
                key={m.key}
                className={`ca-reach-card ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}
                style={{ transitionDelay: `${100 + i * 90}ms` }}
              >
                <div className={`ca-reach-card__viz ca-reach-card__viz--${m.key}`}>
                  <V />
                </div>
                <h3 className="ca-reach-card__title">{m.title}</h3>
                <p className="ca-reach-card__lead">{m.lead}</p>
                <ul className="ca-reach-card__bullets">
                  {m.points.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
